import { render } from "./layout-list.vue?vue&type=template&id=28ce0512&scoped=true"
import script from "./layout-list.vue?vue&type=script&lang=js"
export * from "./layout-list.vue?vue&type=script&lang=js"

import "./layout-list.vue?vue&type=style&index=0&id=28ce0512&lang=scss&scoped=true"

import exportComponent from "/www/publicHouse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ce0512"]])

export default __exports__